<template>
    <div class="form-group ">
        <button type="submit" class="btn btn-primary">
            {{title}}
        </button>
    </div>
</template>

<script>
    export default {
        name: "ButtonSubmit",
        props: ['title'],
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ButtonSubmit.vue